'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var List_module = require('../styles/List.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description Unordered list element.
 *
 * @component
 * @example
 * ```jsx
 * <UnorderedList>...</UnorderedList>
 * ```
 */
const UnorderedList = React__namespace.forwardRef((props, ref) => {
    const { className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(List_module.default);
    const classNames = cx(className, 'unordered');
    return (React__namespace.createElement("ul", { ref: ref, className: classNames, ...restProps }, children));
});
UnorderedList.displayName = 'UnorderedList';

exports.UnorderedList = UnorderedList;
//# sourceMappingURL=UnorderedList.js.map
